<template>
  <div class="welcome_container">
    <div class="welcome_content">
      <div class="content_item">
        <div class="item_title">欢迎语:</div>
        <el-input class="item_textarea" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
          maxlength="50" show-word-limit v-model.trim="form.greeting">
        </el-input>
      </div>
      <div class="content_item">
        <div class="item_title">图片:</div>
        <div class="content_value">
          <div class="flex flex-w">
            <div class="position-r w80 mr8" v-for="(im, imgIndex) in form.imageUrls" :key="im">
              <el-image @click="handlePictureCardPreview($event, imgIndex)" class="mr8 "
                style="width: 80px; height: 80px;border-radius: 2px ;" :src="im">
              </el-image>
              <div class="del" @click="handleRemove(imgIndex)"><i class="el-icon-close size12"></i></div>
            </div>
            <Upload v-if="form.imageUrls.length < 5" v-loading="uploading" ref="uploadImage" @on-success="handleImgSuccess"
              accept=".png,.jpg,.jpeg" class="mr8">
              <el-button class="upload" type="primary" size="small" @click="localUpload">
                <i class="el-icon-plus"></i>
              </el-button>
            </Upload>
          </div>
          <div class="content_tips">支持JPG. PNG，最多支持上传5张</div>
        </div>
      </div>
    </div>
    <el-button type="primary" @click="dialogSave">保存</el-button>
  </div>
</template>

<script>
import Upload from '@/components/Upload/Upload'
import { uploadTemporaryFile } from "@/api/post"; // 科室请求
import { keywordReplyDTO } from "@/DTO/index";
export default {
  components: { Upload },
  data() {
    return {
      uploading: false,
      form:{
        id:'',
        greeting: '',
        imageUrls: [],
      }
    }
  },
  created() {
    this.getGreeting()
  },
  methods: {
    //图片删除
    handleRemove(fileIndex) {
      this.form.imageUrls.splice(fileIndex, 1)
    },

    //图片上传成功
    handleImgSuccess(data) {
      this.uploading = true
      let arr = []
      arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
      uploadTemporaryFile(arr).then(uploadRes => {
        this.uploading = false
        if (uploadRes.errorCode == '0000') {
          this.form.imageUrls.push(uploadRes.data[0].fullPathUrl)
        } else {
          this.$message.error('上传失败')
        }
      }).catch(err => {
        this.uploading = false;
        this.$message.error('上传失败')
      })
    },
    //保存
    async dialogSave() {
      let {code,data} = await keywordReplyDTO.saveGreeting(this.form)
      if(code==200){
        this.$message.success('保存成功')
        this.getGreeting()
      }
    },
    //查询设置
    async getGreeting(){
      let { code, data } = await keywordReplyDTO.getGreeting({id:1})
      if(code==200){
        this.form = data || { id:'',greeting: '',imageUrls: [],}
      }
    },
    localUpload() { },
  }
}
</script>

<style lang="less" scoped>
.welcome_container {
  padding: 20px;
}

.welcome_content {}

.content_item {
  display: flex;
  margin-bottom: 20px;
}

.item_title {
  width: 80px;
  flex-shrink: 0;
}

.content_value {}

.content_tips {
  color: #9AA0A8;
  font-size: 13px;
  margin-top: 8px;
}

.item_textarea {
  width: 700px;
}

.item_textarea /deep/.el-textarea__inner {
  min-height: 100px !important;
}

.upload {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 2px;
  border: 1px dashed #D3D3D5;
  background-color: #FFF;
  color: #9AA0A8;
}

.del {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -2px;
  right: 0px;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  color: #9AA0A8;
  background: #F0F1F3;
}
</style>